import { AbstractFilterHandler } from '../AbstractFilterHandler';
import { FilterOptions } from '@/helpers/filter/models/FilterOptions';
import { FilterData } from '@/helpers/filter/models/FilterData';

export class OnlyMyLessonsFilterHandler extends AbstractFilterHandler {
    public handle(data: FilterData[], filterOptions: FilterOptions): FilterData[] {
        // console.log('OnlyMyLessonsFilterHandler->handle');

        const arr = JSON.parse(JSON.stringify(data)) as FilterData[];
        let res: FilterData[];

        if (filterOptions.onlyMyLessons && filterOptions.onlyMyLessons) {
            res = arr.filter((el: FilterData) => {
                if (el.x_lessons) {
                    el.x_lessons = el.x_lessons.filter((lesson: any) => {
                        return lesson.user_id === filterOptions.userId;
                    });
                } else {
                    el.lessons = el.lessons.filter((lesson: any) => {
                        return lesson.user_id === filterOptions.userId;
                    });
                }

                return el;
            });
        } else {
            res = arr;
        }

        return super.handle(res, filterOptions);
    }
}
